export function openSignInWindow(url) {
  const windowFeatures = "toolbar=no, menubar=no, width=600, height=900, top=100, left=100";
  open(
      url,
      "integratedOnboardingWindow",
      windowFeatures
  );
}
